<template>
  <div class="service">
    <div class="termination__row">
      <div class="form__field">
        <VSelect class="select select--default select--shadow" :class="{ 'select--error': service.companyHasError }"
          :options="companies" :reduce="(company) => company.id" label="name" placeholder="Firma" @update:modelValue="
            updateSpecificTerminationServiceField(index, 'companyId', $event)
            " v-model="terminationService.companyId" />

        <div class="form__error" v-if="service.companyHasError">
          Please select a company
        </div>
      </div>
      <div class="form__field">
        <div v-if="!services.length" class="select select--default select--readonly"
          :class="{ 'select--error': service.serviceHasError }">
          Services
        </div>
        <VSelect v-else :reduce="(service) => service.id" class="select select--default select--shadow"
          :class="{ 'select--error': service.serviceHasError }" :options="services" :label="`long_${language}`"
          placeholder="Services" @update:modelValue="
            updateSpecificTerminationServiceField(index, 'serviceId', $event)
            " v-model="terminationService.serviceId" />

        <div class="form__error" v-if="service.serviceHasError">
          Please select a service
        </div>
      </div>
      <div class="form__field">
        <Datepicker class="input input--default input--shadow" placeholder="Termination Date"
          :class="{ 'select--error': service.dateHasError }" :config="statics.datePickerConfig" @input="
            updateSpecificTerminationServiceField(
              index,
              'terminationDate',
              $event
            )
            " v-model="terminationService.terminationDate" />
        <div class="form__error" v-if="service.dateHasError">
          Please select a date
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, computed } from "vue";
import { useStore } from "vuex";
import statics from "@/statics";
//import { formatDisplayDate } from "@/helpers/dateFormatters";

const store = useStore();

const {service, companies, index, updateSpecificTerminationServiceField} = defineProps({
  service: {
    required: true,
    type: Object,
  },
  companies: {
    required: true,
    type: Array,
  },
  index: {
    required: true,
    type: Number,
  },
  updateSpecificTerminationServiceField: {
    required: true,
    type: Function,
  },
});

// State
const services = ref([]);
const terminationService = ref({
  companyId: "",
  terminationDate: "",
  serviceId: "",
});

// Computed
const language = computed(() => store.getters.language);

// Watcher
watch(
  () => terminationService.value.companyId,
  async (companyId) => {
    try {
      if (companyId) {
        services.value = await store.dispatch("getCompanyServices", companyId);
      }
    } catch (err) {
      console.error(err);
    }
  }
);
</script> 

<style lang="scss" scoped>
.form__field {
  flex: 1;
  margin: 20px 10px 20px 0;

  &:last-child {
    margin-right: 0;
  }
}
</style>
